import { motion } from "framer-motion";
import interior1 from "../../../assets/interior1.jpg";
import interior2 from "../../../assets/interior2.jpg";
import cafeBg from "../../../assets/cafesectionbg.jpeg";
import beautyIcon from "../../../assets/beautyint.png";
import foodIcon from "../../../assets/freshfood.png";

/* ---------- Animations ---------- */

const imageAnim = (x) => ({
  hidden: { opacity: 0, x },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
});

const cardAnim = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: 0.2 },
  },
};

/* ---------- Info Card ---------- */

const InfoCard = ({ iconSrc, title }) => (
  <motion.div
    variants={cardAnim}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    className="bg-white shadow-xl p-3 max-w-[420px]"
  >
    {/* INNER BORDER */}
    <div className="border border-primary-600 p-10 md:p-14 text-center">
      
      {/* ICON */}
      <img
        src={iconSrc}
        alt={title}
        className="mx-auto mb-4 w-12 h-12 object-contain"
      />

      <h3 className="text-lg font-bold tracking-widest text-primary-900">
        {title}
      </h3>

      <div className="w-10 h-px bg-primary-800 mx-auto my-4" />

      <p className="text-sm text-primary-600 leading-relaxed">
        Fish is one of the most wholesome foods that man can eat.
        In fact, people have been eating fish throughout human history.
        These days, many cooks yearn to add fish to their repertoire.
      </p>
    </div>
  </motion.div>
);

/* ---------- Main Section ---------- */

const CafeSection = () => {
  return (
    <section
      className="py-32 px-4 bg-primary-50"
      style={{ backgroundImage: `url(${cafeBg})` }}
    >
      <div className="max-w-7xl mx-auto space-y-40">

        {/* ===== TOP BLOCK ===== */}
        <div className="relative">
          <motion.img
            src={interior1}
            alt="Beautiful Interior"
            className="w-full md:w-[70%] h-[300px] md:h-[420px] object-cover"
            variants={imageAnim(-80)}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          />

          <div className="md:absolute md:right-0 md:top-1/2 md:-translate-y-1/2 -mt-20 md:mt-0 flex justify-center">
            <InfoCard
              iconSrc={beautyIcon}
              title="BEAUTIFUL INTERIOR"
            />
          </div>
        </div>

        {/* ===== BOTTOM BLOCK ===== */}
        <div className="relative">
          <motion.img
            src={interior2}
            alt="Only Fresh Food"
            className="w-full md:w-[70%] md:ml-auto h-[300px] md:h-[420px] object-cover"
            variants={imageAnim(80)}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          />

          <div className="md:absolute md:left-0 md:top-1/2 md:-translate-y-1/2 -mt-20 md:mt-0 flex justify-center">
            <InfoCard
              iconSrc={foodIcon}
              title="ONLY FRESH FOOD"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default CafeSection;
